export default function Footer() {
  return <footer className="footer-banner">Created for you!</footer>;
}
